import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
    startDate: null,
    endDate: null,
    rentalInsurancePolicyId: null,
    charges: [],
    currentCharge: {},
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
